import React from 'react';
import { Checkbox, useStyles } from '@archipro-design/aria';
import * as S from './OptionRadioGroup.mobile.style';

export interface ItemType {
    ID: number;
    label: React.ReactNode;
}

interface Props {
    items: ItemType[];
    selectedID?: number;
    onSelect: (optionID: number) => void;
    visible: boolean;
}

const OptionRadioGroup = ({ visible, items, selectedID, onSelect }: Props) => {
    const { css } = useStyles({ visible });

    return (
        <div className={css(S.OptionRadioGroup)}>
            {items.map((it) => (
                <Checkbox
                    key={'option-' + it.ID}
                    indicator={{ kind: 'radio' }}
                    label={it.label}
                    checked={it.ID === selectedID}
                    onChange={() => onSelect(it.ID)}
                />
            ))}
        </div>
    );
};

export default OptionRadioGroup;
